import { render, staticRenderFns } from "./leftLian.vue?vue&type=template&id=31203d86&scoped=true&"
import script from "./leftLian.vue?vue&type=script&lang=js&"
export * from "./leftLian.vue?vue&type=script&lang=js&"
import style0 from "./leftLian.vue?vue&type=style&index=0&id=31203d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31203d86",
  null
  
)

export default component.exports